module.exports = __webpack_public_path__ + "img/im.ea91a326.svg";